import config from '../config'
class Handels {
    constructor() {
        // 初始化属性
        this.data = []
    }

    // 向数据数组添加元素的方法
    addItem(item) {
        this.data.push(item)
    }

    // 获取数据数组的方法
    getData() {
        return this.data
    }

    // 清空数据数组的方法
    clearData() {
        this.data = []
    }

    GetUrlRelativePath(isAddSuffix = false) {
        var url = document.location.toString()
        //url = "https://qq.com/ceiba/qq/erwrwe/werwer.html";
        var arrUrl = url.split('//')
        var start = arrUrl[1].indexOf('/')
        var relUrl = arrUrl[1].substring(start) //stop省略，截取从start开始到结尾的所有字符
        if (relUrl.indexOf('?') != -1) {
            relUrl = relUrl.split('?')[0]
        }
        relUrl = relUrl.replace('/#/', '')
        if (isAddSuffix) {
            relUrl = relUrl.replace(/.$/, '.json')
        }
        return relUrl.trim()
    }
    //当前语言（重构：优先使用 URL 的 lang 参数，不破坏原有 cookie 逻辑与默认值；当存在 lang 参数时写入 cookie：langeuage）
    CurrentLangeuage(Lowercase = false) {
        const getLangFromUrl = () => {
            // 先读标准查询参数 ?lang=xx
            try {
                const s1 = new URLSearchParams(window.location.search || '')
                if (s1.has('lang')) return s1.get('lang')
            } catch (e) {}
            // 再读 hash 路由中的查询 ?lang=xx
            try {
                const hash = window.location.hash || ''
                const qIndex = hash.indexOf('?')
                if (qIndex !== -1) {
                    const s2 = new URLSearchParams(hash.substring(qIndex))
                    if (s2.has('lang')) return s2.get('lang')
                }
            } catch (e) {}
            return null
        }

        let lang = getLangFromUrl()
        if (lang) {
            // 将 URL 中的语言值写入 cookie，便于其他页面读取
            try {
                const val = String(lang)
                // 保持原始大小写，不影响 Lowercase 的返回行为
                document.cookie = `langeuage=${encodeURIComponent(val)}; path=/; max-age=31536000; samesite=Lax`
            } catch (e) {}
        } else {
            // 回退到现有 cookie 逻辑（保持键名与行为）
            lang = this.getCookie('langeuage')
        }

        if (Lowercase) {
            return lang ? String(lang).toLowerCase() : 'en-us'
        }
        return lang ? String(lang) : 'en-US'
    }

    // 定义一个函数来获取指定名称的 cookie
    getCookie(name) {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(';').shift()
    }
    extractHostSmart(url) {
        // 如果URL没有协议，自动添加https://前缀
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }
        try {
            return new URL(url).host;
        } catch (e) {
            return null;
        }
    }
    
    getApiHost() {
        let url = this.extractHostSmart(config.baseApi)
        // 如果URL没有协议，自动添加https://前缀
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }
        try {
            return new URL(url).host;
        } catch (e) {
            return null;
        }
    }
     getEngineHost() {
        let url = this.extractHostSmart(config.engineApi)
        // 如果URL没有协议，自动添加https://前缀
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }
        try {
            return new URL(url).host;
        } catch (e) {
            return null;
        }
    }




}

// 导出类，以便外部模块可以调用
export default new Handels()